import React from 'react';
import PropTypes from 'prop-types';
import { defaultProps, withHandlers, mapProps } from 'recompose';
import { compose, assoc, when, prop } from 'ramda';

import noop from 'app/libs/noop';
import S from 'app/components/Button/Button.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import CallToAction from 'app/components/layout/CallToAction.styled';

const Button = ({ children, onClick, isLoading, ...restProps }) => (
  <S.Button
    role="button"
    tabIndex="0"
    isLoading={isLoading}
    onClick={isLoading ? noop : onClick}
    data-t={restProps.testId}
    {...restProps}
  >
    <CallToAction as={S.Button.Title} size="m">
      {children}
    </CallToAction>
    {isLoading && (
      <S.Button.Loader
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        data-t="loader-svg"
        aria-labelledby="loader-svg"
        role="img"
      >
        <title id="loader-svg">Loader</title>
        <path
          d="M50 0a50 50 0 1050 50A50 50 0 0050 0zm0 88.92A38.92 38.92 0 1188.92 50 38.92 38.92 0 0150 88.92z"
          opacity=".2"
        />
        <path d="M69.44 16.32l5.54-9.59A49.7 49.7 0 0050 0v11.08a38.74 38.74 0 0119.44 5.24z" />
      </S.Button.Loader>
    )}
  </S.Button>
);

Button.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  testId: PropTypes.string,
};

Button.defaultProps = {
  type: 'primary',
  onClick: noop,
  children: noop,
  isLoading: false,
  testId: '',
};

export { Button };

export default compose(
  defaultProps({ onClick: noop }),
  mapProps(when(prop('to'), assoc('as', LocalizedLink))),
  withHandlers({ onClick: prop('onClick') }),
)(Button);
